import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 'fit-content',
      minHeight: 32,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      padding: theme.spacing(0, 0.75),
      backgroundColor: COLORS.gray.gray80,
      border: theme.shape.borderGray80,
      borderRadius: theme.shape.borderRadiusSmall,
    },
    text: {},
    score: {},
  }),
  { name: 'ImageOverlayChip' }
);
